import React from 'react'
import { Card } from 'src/components/framework/ui'
import { CTA } from 'src/components/framework/ui/cta'
import { SectionHeader } from 'src/components/framework/ui/section-header'

import * as styles from './guru-screens.module.scss'

export const GuruScreens: React.FC = () => {
  return (
    <div className={styles.guruScreens}>
      <SectionHeader>Guru Screens</SectionHeader>
      <Card className={`${styles.guruScreens__card}`} variants={['outlined']}>
        <CTA />
      </Card>
    </div>
  )
}
